"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../../../Grid"));
var Typography_1 = __importDefault(require("../../../../Typography"));
var FileUpload_1 = __importDefault(require("../../../../FileUpload"));
var form_1 = require("../../../context/form");
var props_1 = require("../../../context/props");
var useCheckFilesMaxSize_1 = __importDefault(require("./hooks/useCheckFilesMaxSize"));
var Label_1 = __importDefault(require("./Label"));
var AddButton = function () {
    var onAddFile = (0, form_1.useFormContext)().onAddFile;
    var _a = (0, props_1.usePropsContext)(), translate = _a.translate, maxFilesSize = _a.maxFilesSize, accept = _a.accept, isLoading = _a.isLoading;
    (0, useCheckFilesMaxSize_1.default)();
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(FileUpload_1.default, { label: react_1.default.createElement(Label_1.default, null), onChange: onAddFile, id: "feedback-file", fullWidth: true, variant: "outlined", showControlIcon: false, showSelectedFileName: false, accept: accept, disabled: isLoading })),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(Typography_1.default, { variant: "caption", color: "secondary" }, translate('feedbackModal.fileMaxSize', '', { size: (maxFilesSize / 1024 / 1024).toString() })))));
};
exports.default = AddButton;
